import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { TokenLoginPageComponent } from './token-login-page.component';
import { AuthenticateTokenModule } from './authenticate-token/authenticate-token.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { FeedbackExecutionModule } from 'src/app/shared/feedback-execution/feedback-execution.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'authenticateToken',
    url: '/authenticateToken?a&t&cid&comp',
    params: {
      a: null,
      t: null,
      cid: null,
      comp: null
    },
    component: TokenLoginPageComponent,
    data: {
      requireLogin: false
    }
  }
];

@NgModule({
  declarations: [
    TokenLoginPageComponent
  ],
  imports: [
    CommonModule,
    AuthenticateTokenModule,
    SkeletonLoaderModule,
    FeedbackExecutionModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [TokenLoginPageComponent],
})
export class TokenLoginPageModule { }
